<bb-page-header [icon]="'trash'" [title]="'TRASH' | translate" [filterConfig]="filterConfig"
	[currentPath]="listConfiguration.basePath">
</bb-page-header>

<div class="body-column">

	<div class="action-buttons">
		<span class="button" [ngClass]="{disabled: !deleteRight || totalAmount === 0}" (click)="purgeTrashItems()">
			<i class="fa fa-trash-o"></i>{{ 'EMPTY_TRASH' | translate }}
		</span>
		<div class="with-selected" [ngClass]="{'has-selected': selectedRows.length > 0}">
			<span *ngIf="!selectedRows || selectedRows.length === 0" class="selected-label">{{ 'NO_ITEMS_SELECTED' |
				translate }}</span>
			<span *ngIf="selectedRows.length > 0" class="selected-label">{{ 'WITH_SELECTED' | translate : {value:
				selectedRows.length} }}:</span>

			<span [ngClass]="{disabled: !selectedRows || selectedRows.length === 0 || !putRight}" class="button"
				(click)="restoreMediaclip(selectedRows[0])">
				<i class="fa fa-undo"></i>{{ 'PUT_BACK' | translate }}
			</span>

			<span [ngClass]="{disabled: !selectedRows || selectedRows.length === 0 || !deleteRight}" class="button"
				(click)="purgeMediaclip(selectedRows[0])">
				<i class="fa fa-times-circle"></i>{{ 'PERMANENTLY_DELETE' | translate }}
			</span>
		</div>
	</div>

	<bb-table-container>

		<bb-table-header>
			<bb-table-header-cell property="mediatype" class="column-mediatype">&nbsp;</bb-table-header-cell>
			<bb-table-header-cell property="id">{{ 'ID' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="sourceid" class="overflow">{{ 'NAME' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="createddate" class="date" >{{ 'CREATED' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="createdBy">{{ 'CREATED_BY' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="updateddate" class="date" >{{ 'UPDATED' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="updatedBy">{{ 'UPDATED_BY' | translate }}</bb-table-header-cell>
			<bb-table-header-cell class="buttons"></bb-table-header-cell>
		</bb-table-header>

		<bb-table-row *ngFor="let row of rows" [row]="row">
			<bb-table-cell property="mediatype">
				<div [innerHtml]="row.data | clipIcon"></div>
			</bb-table-cell>
			<bb-table-cell property="id">{{ row.id }}</bb-table-cell>
			<bb-table-cell property="sourceid" [class.alt-color.filename]="!row.data.title" class="overflow">{{
				row.data.title || row.data.originalfilename }}</bb-table-cell>
			<bb-table-cell property="createddate" class="date" [titleValue]="row.data.createddate | bbDate">{{
				row.data.createddate | bbDate:'relative' }}</bb-table-cell>
			<bb-table-cell optional property="createdBy" [titleValue]="row.data.createdBy">{{ row.data.createdBy }}
			</bb-table-cell>
			<bb-table-cell property="updateddate" class="date" [titleValue]="row.data.updateddate | bbDate">{{
				row.data.updateddate | bbDate:'relative' }}</bb-table-cell>
			<bb-table-cell optional property="updatedBy" [titleValue]="row.data.updatedBy">{{ row.data.updatedBy }}
			</bb-table-cell>


			<bb-table-cell class="buttons" (click)="$event.stopPropagation()">
				<!-- stopPropagation so the row doesn't get selected -->
				<a class="button" [ngClass]="{disabled: !putRight}" (click)="restoreMediaclip(row.data)">
					<i class="fa fa-undo"></i>
				</a>
				<a class="button" [ngClass]="{disabled: !deleteRight}" (click)="purgeMediaclip(row.data)">
					<i class="fa fa-times-circle"></i>
				</a>
			</bb-table-cell>

		</bb-table-row>

	</bb-table-container>

	<div class="no-results" *ngIf="rows && !rows.length">{{ 'NO_MEDIA_CLIPS_FOUND' | translate }}</div>

	<bb-table-pager></bb-table-pager>

</div>
